/*
 * @license
 * Copyright© Celligence LLC - 2024
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React, { useState, useEffect, useRef } from "react";
import { Container } from "react-bootstrap";
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import "./NavBar.css";

function NavBar({ data, pageType }) {
  const navBar = data;
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      const isMobile = window.innerWidth <= 991;

      // Background change
      setScrolled(currentY > 50);

      // Mobile: hide on scroll down, show on scroll up
      if (isMobile) {
        if (currentY > lastScrollY.current && currentY > 100) {
          setHidden(true);
        } else {
          setHidden(false);
        }
      }

      lastScrollY.current = currentY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`navbar-wrapper${scrolled ? " navbar-wrapper--scrolled" : ""}${hidden ? " navbar-wrapper--hidden" : ""}${pageType === "cobranded" ? " navbar-wrapper--cobranded" : ""}`}
      aria-label="Main navigation"
    >
      <Container>
        <div className="navbar-wrapper__inner">
          <a href="https://www.swmc.com" target="_blank" rel="noopener noreferrer">
            <img
              src={navBar.swLogo.startsWith("http") ? navBar.swLogo : `${process.env.REACT_APP_IMAGES}${navBar.swLogo}`}
              alt={navBar.swLogoAlt}
              className="navbar-wrapper__sw-logo"
              width={302}
              height={65}
            />
          </a>
          <div className="navbar-wrapper__right">
            {pageType === "cobranded" && (
              <img
                src={`${process.env.REACT_APP_IMAGES}${navBar.expertRealtyLogo}`}
                alt={navBar.expertRealtyLogoAlt}
                className="navbar-wrapper__expert-logo"
                width={243}
                height={58}
                loading="lazy"
              />
            )}
               <div className="userway-div">
            <UserWayAccessibilityMenu color="black" width={40} height={40} />
            </div>
          </div>
        </div>
      </Container>
    </nav>
  );
}

export default React.memo(NavBar);
